import {useGetAndSet} from "./useGetAndSet";
import {createSetFitterHourDataAction} from "../actions/dataActions";

export const useFitterHourData = (params, dataFresh, noFetch) => {
    return useGetAndSet("fittersummary", params, createSetFitterHourDataAction, dataFresh, noFetch);
}